import { useEffect, useState } from "react";
import handlePolicyFromSubmittedData from "../../Services/vendorFromServices";
import useVendorStore from "../../AuthStore/store/authStore";
import { getMutualFundData } from "../../Services/MutualFundServices";
import { useLocation, useNavigate } from "react-router-dom";
import { HiInformationCircle } from "react-icons/hi";
import showLoginToast from "../../Components/CustomHotToast/CustomToast";

const PolicyForm = () => {
  const { authToken, getvendorId, setUser } = useVendorStore();
const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const relations = ["Father", "Mother", "Brother"];
  const location = useLocation();
  const { fundName , fundType} = location.state || {};

  const [MutualFromDatareduse, setMutualFromDataReduse] = useState([]);

  // filtered from data 
  const [selectedType, setSelectedType] = useState("");
  const [selectedFundId, setSelectedFundId] = useState("");
  const [selectedFund, setSelectedFund] = useState(null);

  // ✅ Prefill formData with setUser values
  const [formData, setFormData] = useState({
    name: setUser?.f_name ? `${setUser.f_name} ${setUser.l_name}` : "",
    email: setUser?.email || "",
    phone: setUser?.phone || "",
    date_of_birth: "",
    pan: "",
    aadhar: "",
    nominee: "No",
    nominee_name: "",
    relation_with_nominee: "",
    nominee_gender: "",
    nominee_aadhar: "",
    policy_category: "",
    investment_type: "",
    policy_name: "",
    policy_Id: "",
    amount: "",
    duration_months: "",
  });

  // ✅ Fetch categories, types, policies from backend
  useEffect(() => {
    const fetchMutualFundData = async () => {
      try {
        const response = await getMutualFundData(authToken);
        const groupByTypes = response.reduce((acc, type) => {
          const key = type.type;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(type);
          return acc;


        }, [])

        setMutualFromDataReduse(groupByTypes);



      } catch (error) {
        console.error("Error fetching mutual fund data:", error);
      }
    };

    fetchMutualFundData();
  }, [authToken]);

  // Prefill fund type and fund name if passed via location.state
  useEffect(() => {
  if (fundType && fundName && MutualFromDatareduse[fundType]) {
    setSelectedType(fundType);
    setSelectedFundId(fundName);

    const fund = MutualFromDatareduse[fundType].find(f => f.name === fundName);
    if (fund) {
      setSelectedFund(fund);
    }
  }
}, [fundType, fundName, MutualFromDatareduse]);


  // console.log("MutualFromDatareduse: ", MutualFromDatareduse);


  // Handle type selection
  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setSelectedFundId("");
    setSelectedFund(null);
  };


  // Handle fund name selection
  const handleFundChange = (e) => {
    const fundname = e.target.value;
    // console.log("fundname: ", fundname);

    setSelectedFundId(fundname);
    const fund = MutualFromDatareduse[selectedType]?.find((f) => f.name.toString() === fundname);

    console.log("Selected fund: ", fund);

    setSelectedFund(fund || null);
  };


  // console.log("MutualFromDatareduse: ", MutualFromDatareduse);
useEffect(() => {
  if (formData.nominee === "No") {
    setFormData((prev) => ({
      ...prev,
      nominee_name: "",
      relation_with_nominee: "",
      nominee_gender: "",
      nominee_aadhar: "",
    }));
    setErrors((prev) => ({
      ...prev,
      nominee_name: "",
      relation_with_nominee: "",
      nominee_gender: "",
      nominee_aadhar: "",
    }));
  }
}, [formData.nominee]);



  // ✅ Validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.phone) {
      newErrors.phone = "Phone is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits";
    }
    if (!formData.date_of_birth) newErrors.date_of_birth = "Date of birth is required";
    if (!formData.pan) {
      newErrors.pan = "PAN is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(formData.pan)) {
      newErrors.pan = "PAN format is invalid";
    }
    if (!formData.aadhar) {
      newErrors.aadhar = "Aadhar is required";
    } else if (!/^[2-9]\d{11}$/.test(formData.aadhar)) {
      newErrors.aadhar = "Aadhaar must be 12 digits and start with 2–9";
    }
    if (formData.nominee === "Yes") {
      if (!formData.nominee_name) newErrors.nominee_name = "Nominee name is required";
      if (!formData.relation_with_nominee) newErrors.relation_with_nominee = "Relation is required";
      if (!formData.nominee_gender) newErrors.nominee_gender = "Gender is required";
      if (!formData.nominee_aadhar) {
        newErrors.nominee_aadhar = "Nominee Aadhar is required";
      } else if (!/^\d{12}$/.test(formData.nominee_aadhar)) {
        newErrors.nominee_aadhar = "Nominee Aadhar must be 12 digits";
      }
    }
    if (!formData.policy_category) newErrors.policy_category = "Policy category is required";
    if (!formData.investment_type) newErrors.investment_type = "Investment type is required";
    if (!formData.policy_name) newErrors.policy_name = "Policy name is required";
    if (!formData.amount || formData.amount <= 0) newErrors.amount = "Valid amount is required";
    if (!formData.duration_months || formData.duration_months <= 0) {
      newErrors.duration_months = "Valid duration is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  useEffect(() => {
    if (selectedFund) {
      setFormData((prev) => ({
        ...prev,

        policy_Id: selectedFund.id,
        policy_category: selectedFund.category,

      }));
    }
  }, [selectedFund]);


  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      const firstError = Object.keys(errors)[0];
      if (firstError) {
        document.querySelector(`[name="${firstError}"]`)?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await handlePolicyFromSubmittedData(formData, authToken, getvendorId);
      // alert( response?.message);

      showLoginToast.success(response?.message||"Form submitted successfully!");

      // Reset form but keep setUser values
      setFormData({
        name: setUser?.f_name ? `${setUser.f_name} ${setUser.l_name}` : "",
        email: setUser?.email || "",
        phone: setUser?.phone || "",
        date_of_birth: "",
        pan: "",
        aadhar: "",
        nominee: "No",
        nominee_name: "",
        relation_with_nominee: "",
        nominee_gender: "",
        nominee_aadhar: "",
        policy_category: "",
        investment_type: "",
        policy_name: "",
        amount: "",
        duration_months: "",
      });

      if (response) {
        setTimeout(()=>{
          navigate(-1);
        },[2500])
      }

    } catch (err) {
      // console.error("Error submitting form:", err);

      Object.keys(err).forEach(key => {
        showLoginToast.error(err[key]);
      // alert(`${key}: ${err[key]}`);

});
      
    } finally {
      setIsSubmitting(false);
    }
  };

  console.log(" Submitting Form Data: ", formData);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-6 px-4 -mt-10">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-2xl shadow-xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-700 mb-2">Policy Application Form</h1>
          <p className="text-gray-600">Fill in your details to apply for a new policy</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Personal Information Section */}
            <div className="md:col-span-2">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center"> <span className="bg-blue-100 p-2 rounded-full mr-2"> <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 " fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /> </svg> </span> Personal Information </h3>
            </div>

            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                disabled={!!setUser?.f_name}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.name ? "border-red-500" : "border-gray-300"} ${!!setUser?.f_name ? "bg-gray-100" : ""}`}
                placeholder="John Doe"
              />
              {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                disabled={!!setUser?.email}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.email ? "border-red-500" : "border-gray-300"} ${!!setUser?.email ? "bg-gray-100" : ""}`}
                placeholder="john@example.com"
              />
              {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                disabled={!!setUser?.phone}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.phone ? "border-red-500" : "border-gray-300"} ${!!setUser?.phone ? "bg-gray-100" : ""}`}
                placeholder="9876543210"
              />
              {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
            </div>

            {/* Date of Birth */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth *</label>
              <input
                type="date"
                name="date_of_birth"
                value={formData.date_of_birth}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.date_of_birth ? "border-red-500" : "border-gray-300"}`}
              />
              {errors.date_of_birth && <p className="mt-1 text-sm text-red-600">{errors.date_of_birth}</p>}
            </div>

            {/* PAN */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">PAN *</label>
              <input
                type="text"
                name="pan"
                value={formData.pan.trim().toUpperCase()}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.pan ? "border-red-500" : "border-gray-300"}`}
                placeholder="ABCDE1234F"
              />
              {errors.pan && <p className="mt-1 text-sm text-red-600">{errors.pan}</p>}
            </div>

            {/* Aadhar */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Aadhar *</label>
              <input
                type="text"
                name="aadhar"
                value={formData.aadhar}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.aadhar ? "border-red-500" : "border-gray-300"}`}
                placeholder="123456789012"
              />
              {errors.aadhar && <p className="mt-1 text-sm text-red-600">{errors.aadhar}</p>}
            </div>

            {/* Nominee */}
            <div className="md:col-span-2">
              <h3 className="text-lg font-semibold text-gray-800  mb-4 flex items-center"> <span className="bg-blue-100 p-2 rounded-full mr-2"> <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 " fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /> </svg> </span> Nominee Information </h3>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="nominee"
                    value="No"
                    checked={formData.nominee === "No"}
                    onChange={handleChange}
                    className="text-indigo-600 focus:ring-indigo-500"
                  />
                  <span className="ml-2">No</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="nominee"
                    value="Yes"
                    checked={formData.nominee === "Yes"}
                    onChange={handleChange}
                    className="text-indigo-600 focus:ring-indigo-500"
                  />
                  <span className="ml-2">Yes</span>
                </label>
              </div>
            </div>

            {formData.nominee === "Yes" && (
              <>
                <div className="md:col-span-2">
                  <h3 className="text-lg font-medium text-indigo-600 mt-4 mb-2">Nominee Details</h3>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nominee Name *</label>
                  <input
                    type="text"
                    name="nominee_name"
                    value={formData.nominee_name}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.nominee_name ? "border-red-500" : "border-gray-300"}`}
                    placeholder="Nominee Full Name"
                  />
                  {errors.nominee_name && <p className="mt-1 text-sm text-red-600">{errors.nominee_name}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Relation *</label>
                  <select
                    name="relation_with_nominee"
                    value={formData.relation_with_nominee}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.relation_with_nominee ? "border-red-500" : "border-gray-300"}`}
                  >
                    <option value="">Select Relation</option>
                    {relations.map((rel) => (
                      <option key={rel} value={rel}>
                        {rel}
                      </option>
                    ))}
                  </select>
                  {errors.relation_with_nominee && <p className="mt-1 text-sm text-red-600">{errors.relation_with_nominee}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nominee Gender *</label>
                  <select
                    name="nominee_gender"
                    value={formData.nominee_gender}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.nominee_gender ? "border-red-500" : "border-gray-300"}`}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.nominee_gender && <p className="mt-1 text-sm text-red-600">{errors.nominee_gender}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nominee Aadhar *</label>
                  <input
                    type="text"
                    name="nominee_aadhar"
                    value={formData.nominee_aadhar}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.nominee_aadhar ? "border-red-500" : "border-gray-300"}`}
                    placeholder="923456789012"
                  />
                  {errors.nominee_aadhar && <p className="mt-1 text-sm text-red-600">{errors.nominee_aadhar}</p>}
                </div>
              </>
            )}

            {/* Policy Information Section */}
            <div className="md:col-span-2 mt-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center"> <span className="bg-blue-100 p-2 rounded-full mr-2"> <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 " fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /> </svg> </span> Policy Details </h3>
            </div>

            {/* Investment Type */}
            <div className="md:col-span-2 p-6 bg-white shadow-md rounded-md">


              {/* Investment Type Dropdown */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Investment Type</label>
                <select
                  name="investment_type"
                  value={selectedType}
                  onChange={(e) => {
                    handleTypeChange(e);
                    handleChange(e)
                  }

                  }
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                >
                  <option value="">Select Type</option>
                  {Object.keys(MutualFromDatareduse).map((type) => (
                    <option key={type} value={type}>
                      {type.toUpperCase()}
                    </option>
                  ))}
                </select>
                {/* Mutual Fund Name Dropdown */}

              </div>

              {selectedType && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Mutual Fund Name</label>
                  <select
                    value={selectedFundId}

                    onChange={(e) => {
                      handleFundChange(e);
                      handleChange(e)
                    }
                    }
                    name="policy_name"

                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                  >
                    <option value="">Select Fund</option>
                    {MutualFromDatareduse[selectedType].map((fund) => (
                      <option key={fund.id} value={fund.name}>
                        {fund.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Fund Details */}
              {selectedFund && (
                <div className="mt-8 border-t border-gray-300 pt-6 w-full">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                    <svg className="w-5 h-5 text-indigo-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-6 0H5m2 0h4m4 0v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4m4-6v-2a2 2 0 00-2-2H9a2 2 0 00-2 2v2"></path>
                    </svg>
                    Fund Details
                  </h3>

                  {/* Hidden inputs */}
                  <input type="hidden" name="policy_category" value={formData.policy_category} />
                  <input type="hidden" name="policy_Id" value={selectedFund.id} />

                  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
                    {/* Input fields section */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
                      {/* Amount Input */}
                      <div>
                        <label className=" text-sm font-medium text-gray-700 mb-2 flex items-center">
                          Investment Amount
                          <span className="text-red-500 ml-1">*</span>
                          <span className="ml-2 text-xs text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full">Min: ₹{selectedFund.min_amount}</span>
                        </label>
                        <div className="relative">
                          <span className="absolute left-3 top-3 text-gray-500">₹</span>
                          <input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            className={`w-full pl-8 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.amount ? "border-red-500" : "border-gray-300"}`}
                            placeholder="5000"
                            min={selectedFund.min_amount}
                          />
                        </div>
                        {errors.amount && <p class="mt-1 text-sm text-red-600 flex items-center">
                          <HiInformationCircle className="w-4 h-4 mr-1 text-gray-600" />

                          {errors.amount}
                        </p>}
                      </div>

                      {/* Tenure Input */}
                      <div>
                        <label class="text-sm font-medium text-gray-700 mb-2 flex items-center">
                          Tenure (Months)
                          <span className="text-red-500 ml-1">*</span>
                          <span class="ml-2 text-xs text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full">Min: {selectedFund.min_tenure} months</span>
                        </label>
                        <div className="relative">
                          <input
                            type="number"
                            name="duration_months"
                            value={formData.duration_months}
                            onChange={handleChange}
                            className={`w-full pl-4 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition ${errors.duration_months ? "border-red-500" : "border-gray-300"}`}
                            placeholder="12"
                            min={selectedFund.min_tenure}
                          />
                          <span className="absolute right-3 top-3 text-gray-500">months</span>
                        </div>
                        {errors.duration_months && <p class="mt-1 text-sm text-red-600 flex items-center">
                          <HiInformationCircle className="w-4 h-4 mr-1 text-gray-600" />
                          {errors.duration_months}
                        </p>}
                      </div>
                    </div>

                    {/* Fund details section */}
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <h4 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
                        <svg className="w-4 h-4 text-gray-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        Fund Information
                      </h4>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {selectedFund.annual_return && (
                          <div className="flex items-center">
                            <span className="text-sm text-gray-600 font-medium mr-2">Annual Return:</span>
                            <span className="text-sm font-semibold text-green-600">{selectedFund.annual_return}%</span>
                          </div>
                        )}
                        {selectedFund.category && (
                          <div className="flex items-center">
                            <span className="text-sm text-gray-600 font-medium mr-2">Category:</span>
                            <span className="text-sm text-gray-800">{selectedFund.category}</span>
                          </div>
                        )}
                        {selectedFund.fund_age && (
                          <div className="flex items-center">
                            <span className="text-sm text-gray-600 font-medium mr-2">Fund Age:</span>
                            <span className="text-sm text-gray-800">{selectedFund.fund_age} months</span>
                          </div>
                        )}
                        <div class="flex items-center">
                          <span className="text-sm text-gray-600 font-medium mr-2">Minimum Amount:</span>
                          <span className="text-sm text-gray-800">₹{selectedFund.min_amount}</span>
                        </div>
                        <div className="flex items-center">
                          <span className="text-sm text-gray-600 font-medium mr-2">Minimum Tenure:</span>
                          <span className="text-sm text-gray-800">{selectedFund.min_tenure} months</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

          </div>
          {/* <MutualFundForm/> */}

          {/* Submit */}
          <div className="pt-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-md hover:shadow-lg"
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                "Submit Application"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PolicyForm;